// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1eDKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNodeStyleNormal", ()=>getNodeStyleNormal);
parcelHelpers.export(exports, "getNodeStyleClick", ()=>getNodeStyleClick);
parcelHelpers.export(exports, "getNodeStyleHover", ()=>getNodeStyleHover);
var _style = require("ol/style");
function getNodeStyleNormal(feature, editMode = false) {
    return getNodeStyle(feature, false, false, editMode);
}
function getNodeStyleClick(feature) {
    return getNodeStyle(feature, true, false, true);
}
function getNodeStyleHover(feature) {
    return getNodeStyle(feature, false, true, true);
}
function isConnector(feature) {
    return feature.getKeys().some((key)=>key.endsWith("-connector") && feature.get(key) === "yes");
}
function getNodeStyle(feature, click, hover, editMode) {
    if (feature.getGeometry().getType() !== "Point") return [];
    const connector = isConnector(feature);
    // In normal mode, only show connectors. In edit mode, show all nodes.
    if (!editMode && !connector) return [];
    let radius, strokeColor, fillColor;
    if (connector) {
        radius = editMode ? 8 : 3;
        strokeColor = "grey";
        fillColor = "pink";
    } else {
        radius = editMode ? 5 : 2;
        strokeColor = "green";
        fillColor = "white";
    }
    if (hover) radius = editMode ? 10 : 6;
    if (click) {
        fillColor = "orange";
        radius = editMode ? 10 : 6;
    }
    return [
        new (0, _style.Style)({
            image: new (0, _style.Circle)({
                fill: new (0, _style.Fill)({
                    color: fillColor
                }),
                stroke: new (0, _style.Stroke)({
                    color: strokeColor,
                    width: 1
                }),
                radius: radius
            })
        })
    ];
}

},{"ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9xCCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGradientInteractions", ()=>getGradientInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _gradient = require("../style/gradient");
function getGradientInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _gradient.getGradientStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _gradient.getGradientStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/gradient":"2PV5O","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2PV5O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGradientStyleNormal", ()=>getGradientStyleNormal);
parcelHelpers.export(exports, "getGradientStyleClick", ()=>getGradientStyleClick);
parcelHelpers.export(exports, "getGradientStyleHover", ()=>getGradientStyleHover);
var _style = require("ol/style");
var _linearStyling = require("./linearStyling");
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _default = require("./default");
function getGradientStyleNormal(feature) {
    return getGradientColorStyle(feature);
}
function getGradientStyleClick(feature) {
    return getGradientColorStyle(feature, true, false);
}
function getGradientStyleHover(feature) {
    return getGradientColorStyle(feature, false, true);
}
function getGradientColorStyle(feature, click, hover) {
    let width, backgroundColor, backgroundWidth;
    let orbisGradient = feature.get("orbis-gradient");
    if (orbisGradient === undefined) orbisGradient = feature.get("orbis-gradient:linear");
    if (orbisGradient === undefined) return (0, _default.getDefaultColorStyle)(feature, click, hover);
    else {
        if (hover) backgroundColor = "black";
        else if (click) backgroundColor = "orange";
        else backgroundColor = "black";
        if (hover || click) {
            width = 7;
            backgroundWidth = 10;
        } else {
            width = 5;
            backgroundWidth = 9;
        }
        const flowStyle = (0, _linearStyling.getLinearTagFlowStyle)(orbisGradient, width, feature, (0, _d3ScaleChromatic.interpolateYlOrRd));
        return [
            flowStyle,
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: backgroundColor,
                    width: backgroundWidth
                })
            })
        ];
    }
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"./linearStyling":"1P32G","d3-scale-chromatic":[["interpolateYlOrRd","dgc6n","default"]],"./default":"e6A2s","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dgc6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"3Mhvi","../ramp.js":"cmbZB","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"3Mhvi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cmbZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Interpolate = require("d3-interpolate");
exports.default = (scheme)=>(0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);

},{"d3-interpolate":[["interpolateRgbBasis","8Ihjm","rgbBasis"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hf098":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOnewayInteractions", ()=>getOnewayInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _oneway = require("../style/oneway");
function getOnewayInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _oneway.getOnewayStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _oneway.getOnewayStyleHover)(feature);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/oneway":"htDSk","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"htDSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOnewayStyleNormal", ()=>getOnewayStyleNormal);
parcelHelpers.export(exports, "getOnewayStyleClick", ()=>getOnewayStyleClick);
parcelHelpers.export(exports, "getOnewayStyleHover", ()=>getOnewayStyleHover);
parcelHelpers.export(exports, "getArrowStyle", ()=>getArrowStyle);
var _style = require("ol/style");
var _supportedHighwayTypes = require("./supportedHighwayTypes");
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _node = require("./node");
var _propertyExtraction = require("./propertyExtraction");
function getOnewayStyleNormal(feature) {
    return getOnewayColorStyle(feature).concat(getArrowStyle(feature)).concat((0, _node.getNodeStyleNormal)(feature));
}
function getOnewayStyleClick(feature) {
    return getOnewayColorStyle(feature, true, false).concat(getArrowStyle(feature)).concat((0, _node.getNodeStyleClick)(feature, true, false));
}
function getOnewayStyleHover(feature) {
    return getOnewayColorStyle(feature, false, true).concat(getArrowStyle(feature)).concat((0, _node.getNodeStyleHover)(feature, false, true));
}
function getOnewayColorStyle(feature, click, hover) {
    let color;
    let lineDash = null;
    const osmOneway = feature.get("7-oneway");
    const orbisOneway = (0, _propertyExtraction.getPropertyEndingWithExcludingLayer7)(feature, "-oneway");
    const orbisOnewayIsLR = orbisOneway !== undefined && orbisOneway.includes("#");
    const osmHighway = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-highway");
    const osmJunction = (0, _propertyExtraction.getPropertyEndingWith)(feature, "-junction");
    if (osmHighway === undefined) color = "black";
    else if (!(0, _supportedHighwayTypes.ONEWAY_HIGHWAY_TYPES).includes(osmHighway)) color = "grey";
    else if (osmHighway === "motorway" && orbisOneway === undefined) color = "red";
    else if (osmOneway === "no" && orbisOneway === undefined) color = "blue";
    else if ((osmJunction === "roundabout" || osmJunction === "circular") && hasSameOneWayValueOnImplicitOneway(osmOneway, orbisOneway)) color = "blue";
    else if (osmOneway != orbisOneway) {
        if (orbisOnewayIsLR) {
            color = "violet";
            lineDash = [
                1,
                3
            ];
        } else color = "red";
    } else color = "blue";
    if (click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: 6
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "orange",
                width: 4,
                lineDash: lineDash
            })
        })
    ];
    if (hover) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: "white",
                width: 8
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: 4,
                lineDash: lineDash
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: 2,
                lineDash: lineDash
            })
        })
    ];
}
function hasSameOneWayValueOnImplicitOneway(osmOneway, orbisOneway) {
    return osmOneway === undefined && orbisOneway === "yes" || osmOneway === "yes" && orbisOneway === undefined || osmOneway === orbisOneway;
}
function getArrowStyle(feature) {
    const orbisOneway = (0, _propertyExtraction.getPropertyEndingWithExcludingLayer7)(feature, "-oneway");
    const styles = [];
    if (typeof feature.getGeometry().forEachSegment === "function") feature.getGeometry().forEachSegment(function(start, end) {
        const mid = [
            (start[0] + end[0]) / 2,
            (start[1] + end[1]) / 2
        ];
        const dx = end[0] - start[0];
        const dy = end[1] - start[1];
        const rotation = Math.atan2(dy, dx);
        // arrows
        if (orbisOneway === "yes") styles.push(new (0, _style.Style)({
            geometry: new (0, _pointDefault.default)(mid),
            image: new (0, _style.Icon)({
                src: "icon-arrow.png",
                anchor: [
                    0.75,
                    0.5
                ],
                rotateWithView: true,
                rotation: -rotation,
                color: "green",
                scale: [
                    0.5,
                    0.5
                ]
            })
        }));
        if (orbisOneway === "-1") styles.push(new (0, _style.Style)({
            geometry: new (0, _pointDefault.default)(mid),
            image: new (0, _style.Icon)({
                src: "icon-arrow.png",
                anchor: [
                    0.75,
                    0.5
                ],
                rotateWithView: true,
                rotation: -rotation + Math.PI,
                color: "green",
                scale: [
                    0.5,
                    0.5
                ]
            })
        }));
    });
    return styles;
}

},{"ol/style":[["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"./supportedHighwayTypes":"90HT0","ol/geom/Point":"95T6m","./node":"1eDKT","./propertyExtraction":"i6VX6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hGnEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addWFSLayerAndControl", ()=>addWFSLayerAndControl);
var _vectorFeatureControl = require("../controls/VectorFeatureControl");
var _revisionControl = require("../controls/RevisionControl");
var _revisionService = require("../services/RevisionService");
var _wfslayer = require("../layers/WFSLayer");
var _hoverLayer = require("../layers/HoverLayer");
var _urlstateManager = require("../state/URLStateManager");
function addWFSLayerAndControl({ layerName, url, role, style, azureLoginControl, featureInfoControl, div, map, getInteractions, featureInfoHandlers, hoverStyleFunctions, addFeatureHandlers = [] }) {
    const slug = (0, _urlstateManager.getLayerSlug)(layerName);
    const control = new (0, _vectorFeatureControl.VectorFeatureControl)({
        layer_name: layerName,
        target: div
    });
    // Restore layer visibility from URL.
    if ((0, _urlstateManager.getLayersFromURL)().includes(slug)) control.setToggle(true);
    (0, _urlstateManager.registerLayerControl)(slug, control);
    // Revision state shared between the control and the layer URL builder
    let currentRevisionParams = [];
    let hasAppliedUrlRevisions = false;
    const revisionControl = new (0, _revisionControl.RevisionControl)({
        headerEl: control.headerEl,
        bodyEl: control.bodyEl
    });
    (0, _urlstateManager.registerRevisionControl)(slug, revisionControl);
    // Fetch revisions once the auth token is available (or immediately if already set)
    function tryFetchRevisions() {
        const token = azureLoginControl.get("idToken");
        if (!token) return;
        (0, _revisionService.fetchRevisions)(url, token).then((layerRevisions)=>{
            let revisionsToUse = layerRevisions;
            let restoredFromUrl = false;
            // Apply URL revision overrides on first load only
            if (!hasAppliedUrlRevisions) {
                hasAppliedUrlRevisions = true;
                const urlRevisions = (0, _urlstateManager.getRevisionsFromURL)();
                const slugRevisions = urlRevisions.get(slug) || [];
                if (slugRevisions.length > 0) {
                    restoredFromUrl = true;
                    revisionsToUse = layerRevisions.map((lr)=>{
                        const match = slugRevisions.find((u)=>u.layerId === lr.layerId);
                        return match ? {
                            ...lr,
                            revision: match.revision
                        } : lr;
                    });
                    // Check if any revision actually differs from the latest
                    const hasOverride = revisionsToUse.some((r, i)=>r.revision !== layerRevisions[i].revision);
                    if (hasOverride) revisionControl.expand();
                }
            }
            const newRevisionParams = (0, _revisionService.buildRevisionParams)(revisionsToUse);
            const changed = newRevisionParams.length !== currentRevisionParams.length || newRevisionParams.some((p, i)=>p !== currentRevisionParams[i]);
            revisionControl.setRevisions(revisionsToUse);
            currentRevisionParams = newRevisionParams;
            if (restoredFromUrl) // Restored from URL: publish through the RevisionControl (its
            // selectedRevisions handler below forwards to the layer control and
            // refreshes the data). This also lets URLStateManager re-serialize
            // the revisions: the initial pushState runs before this async fetch
            // resolves and would otherwise drop the revision state from the URL.
            revisionControl.set("selectedRevisions", revisionsToUse);
            else if (changed) control.set("selectedRevisions", revisionsToUse);
        }).catch((err)=>{
            revisionControl.setError(err);
        });
    }
    // Try immediately; also re-fetch whenever the token changes (login/logout)
    tryFetchRevisions();
    azureLoginControl.on("propertychange", function(e) {
        if (e.key === "idToken") tryFetchRevisions();
    });
    // Re-fetch when the user clicks "Update to latest revisions"
    revisionControl.on("propertychange", function(e) {
        if (e.key === "refreshRequested") {
            revisionControl.setLoading();
            tryFetchRevisions();
        }
    });
    // Keep currentRevisionParams in sync when the user adjusts a revision value
    revisionControl.on("propertychange", function(e) {
        if (e.key === "selectedRevisions") {
            currentRevisionParams = (0, _revisionService.buildRevisionParams)(revisionControl.get("selectedRevisions"));
            // Forward to VectorFeatureControl so WFSLayer can react
            control.set("selectedRevisions", revisionControl.get("selectedRevisions"));
        }
    });
    const wfsUrl = url + "/wfs";
    const layer = (0, _wfslayer.getWFSLayer)(azureLoginControl, control, wfsUrl, role, style, addFeatureHandlers, ()=>currentRevisionParams);
    map.addControl(control);
    map.addControl(revisionControl);
    map.addLayer(layer);
    hoverStyleFunctions.forEach((hoverStyleFunction)=>{
        const hoverLayer = (0, _hoverLayer.getHoverLayer)(hoverStyleFunction);
        map.addLayer(hoverLayer);
        featureInfoControl.addHoverLayerForLayer(hoverLayer, layer);
    });
    featureInfoHandlers.forEach((handler)=>featureInfoControl.addHandlerForLayer(handler, layer));
    getInteractions(layer, control).forEach((interaction)=>map.addInteraction(interaction));
    map.on("moveend", function() {
        control.set("zoom", map.getView().getZoom());
    });
    azureLoginControl.on("propertychange", function() {
        layer.getSource().refresh();
    });
}

},{"../controls/VectorFeatureControl":"ghYyc","../controls/RevisionControl":"gY1RF","../services/RevisionService":"69nZA","../layers/WFSLayer":"bLBLu","../layers/HoverLayer":"3Tely","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gY1RF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Renders a per-layerId revision picker inside the VectorFeatureControl row.
 *
 * The toggle icon is appended into `options.headerEl` (inline with the label).
 * The panel with revision rows is inserted into `options.bodyEl` before the
 * attributes table, so it flows naturally in the document when expanded.
 *
 * Fires "selectedRevisions" property change when any value changes.
 * Fires "refreshRequested" property change when the refresh button is clicked.
 */ parcelHelpers.export(exports, "RevisionControl", ()=>RevisionControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
class RevisionControl extends (0, _controlDefault.default) {
    /**
   * @param {{ headerEl: HTMLElement, bodyEl: HTMLElement }} options
   */ constructor(options = {}){
        // OL Control needs an element — use a hidden placeholder
        const placeholder = document.createElement("span");
        super({
            element: placeholder,
            target: options.headerEl
        });
        // ── Toggle button (icon) — lives inline in the header ──────────────────
        const toggleBtn = document.createElement("button");
        toggleBtn.type = "button";
        toggleBtn.className = "revision-toggle-btn";
        toggleBtn.title = "Show revisions";
        const icon = document.createElement("img");
        icon.src = "history.png";
        icon.alt = "Revisions";
        icon.className = "revision-toggle-icon";
        toggleBtn.appendChild(icon);
        // Loading indicator shown inside the button until revisions arrive
        const statusEl = document.createElement("span");
        statusEl.className = "revision-loading";
        statusEl.title = "Loading revisions\u2026";
        statusEl.textContent = "\u2026";
        toggleBtn.appendChild(statusEl);
        // ── Panel — lives in the body, flows inline below the header ───────────
        const panel = document.createElement("div");
        panel.className = "revision-panel";
        panel.hidden = true;
        toggleBtn.addEventListener("click", ()=>{
            panel.hidden = !panel.hidden;
            toggleBtn.classList.toggle("revision-toggle-btn--open", !panel.hidden);
            toggleBtn.title = panel.hidden ? "Show revisions" : "Hide revisions";
        });
        // Append the icon to the header; insert panel before attributes table
        if (options.headerEl) options.headerEl.appendChild(toggleBtn);
        if (options.bodyEl) {
            // Insert after the header div (first child), before anything else
            const header = options.bodyEl.querySelector(".vector-feature-header");
            if (header && header.nextSibling) options.bodyEl.insertBefore(panel, header.nextSibling);
            else options.bodyEl.appendChild(panel);
        }
        this._toggleBtn = toggleBtn;
        this._statusEl = statusEl;
        this._panel = panel;
        this._revisions = [];
        this._refreshBtn = null;
    }
    setRevisions(layerRevisions) {
        this._revisions = layerRevisions.map((lr)=>({
                ...lr
            }));
        this._statusEl.remove();
        this._render();
    }
    setError(err) {
        this._statusEl.className = "revision-error";
        this._statusEl.textContent = " \u26A0";
        this._statusEl.title = "";
        const detail = err?.message ?? "Failed to load revisions";
        this._panel.innerHTML = "";
        const msg = document.createElement("p");
        msg.className = "revision-error";
        msg.textContent = `Revisions unavailable \u{2014} ${detail}`;
        this._panel.appendChild(msg);
    }
    setLoading() {
        if (this._refreshBtn) {
            this._refreshBtn.disabled = true;
            this._refreshBtn.textContent = "Updating\u2026";
        }
    }
    expand() {
        this._panel.hidden = false;
        this._toggleBtn.classList.add("revision-toggle-btn--open");
        this._toggleBtn.title = "Hide revisions";
    }
    // ── private ────────────────────────────────────────────────────────────────
    _render() {
        this._panel.innerHTML = "";
        if (this._revisions.length === 0) return;
        this._revisions.forEach((lr)=>{
            const row = document.createElement("div");
            row.className = "revision-row";
            const label = document.createElement("span");
            label.className = "revision-layer-id";
            label.textContent = `layer ${lr.layerId}`;
            const minusBtn = document.createElement("button");
            minusBtn.className = "revision-btn";
            minusBtn.type = "button";
            minusBtn.textContent = "\u2212";
            const input = document.createElement("input");
            input.type = "number";
            input.className = "revision-input";
            input.value = String(lr.revision);
            input.min = "0";
            const plusBtn = document.createElement("button");
            plusBtn.className = "revision-btn";
            plusBtn.type = "button";
            plusBtn.textContent = "+";
            minusBtn.addEventListener("click", ()=>{
                const current = parseInt(input.value, 10) || 0;
                if (current > 0) input.value = String(current - 1);
                this._updateRevision(lr, input);
            });
            plusBtn.addEventListener("click", ()=>{
                const current = parseInt(input.value, 10) || 0;
                input.value = String(current + 1);
                this._updateRevision(lr, input);
            });
            input.addEventListener("change", ()=>this._updateRevision(lr, input));
            row.appendChild(label);
            row.appendChild(minusBtn);
            row.appendChild(input);
            row.appendChild(plusBtn);
            this._panel.appendChild(row);
        });
        const refreshBtn = document.createElement("button");
        refreshBtn.className = "revision-refresh-btn";
        refreshBtn.type = "button";
        refreshBtn.textContent = "\u21BA Update to latest revisions";
        refreshBtn.title = "Re-fetch the latest revisions from the server";
        refreshBtn.addEventListener("click", ()=>{
            this.set("refreshRequested", Date.now());
        });
        this._refreshBtn = refreshBtn;
        this._panel.appendChild(refreshBtn);
    }
    _updateRevision(lr, input) {
        lr.revision = parseInt(input.value, 10) || 0;
        this.set("selectedRevisions", this._revisions.map((r)=>({
                ...r
            })));
    }
}

},{"ol/control/Control":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"69nZA":[function(require,module,exports,__globalThis) {
/**
 * Fetches the revision snapshot for a given WFS base URL.
 *
 * @param {string} baseUrl  The root URL of the WFS instance (e.g. "https://host/wfs-oneway").
 *                          The "/revision" path will be appended automatically.
 * @param {string} authToken  Bearer token for the Authorization header.
 * @returns {Promise<Array<{layerId: number, revision: number}>>}
 *   A flat array of { layerId, revision } objects, merging parentLayerRevisions,
 *   otherLayerRevisions and relationLayerRevisions — without category labels.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchRevisions", ()=>fetchRevisions);
/**
 * Converts an array of { layerId, revision } objects into "layerId:revision"
 * strings suitable for use as repeated REVISION= query parameters.
 *
 * @param {Array<{layerId: number, revision: number}>} layerRevisions
 * @returns {string[]}  e.g. ["123:456", "789:12"]
 */ parcelHelpers.export(exports, "buildRevisionParams", ()=>buildRevisionParams);
async function fetchRevisions(baseUrl, authToken) {
    const url = baseUrl + "/revision";
    const response = await fetch(url, {
        headers: {
            Authorization: "Bearer " + authToken
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch revisions from ${url}: ${response.status} ${response.statusText}`);
    const data = await response.json();
    const all = [
        ...data.parentLayerRevisions ?? [],
        ...data.otherLayerRevisions ?? [],
        ...data.relationLayerRevisions ?? []
    ];
    // Deduplicate by layerId — last occurrence wins.
    const byLayerId = new Map(all.map((lr)=>[
            lr.layerId,
            lr
        ]));
    return Array.from(byLayerId.values());
}
function buildRevisionParams(layerRevisions) {
    return layerRevisions.map(({ layerId, revision })=>`${layerId}:${revision}`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bLBLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// API parameters
/**
 * @param {AzureLoginControl} azureLoginControl
 * @param {WFSControl} vectorFeatureControl
 * @param {url} url
 * @param {function} getStyleNormal
 * @returns
 */ parcelHelpers.export(exports, "getWFSLayer", ()=>getWFSLayer);
var _vector = require("ol/source/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/layer/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _geoJSON = require("ol/format/GeoJSON");
var _geoJSONDefault = parcelHelpers.interopDefault(_geoJSON);
var _loadingstrategy = require("ol/loadingstrategy");
var _proj = require("ol/proj");
var _featureLoaderWithHeaders = require("../featureLoaderWithHeaders");
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _util = require("../util");
function getWFSLayer(azureLoginControl, vectorFeatureControl, url, role, getStyleNormal, addFeatureHandlers = [], getRevisionParams = ()=>[]) {
    const vectorSource = new (0, _vectorDefault.default)({
        loader: (0, _featureLoaderWithHeaders.xhr)(function(extent, resolution, projection) {
            const extentTransformed = (0, _proj.transformExtent)(extent, projection, "EPSG:4326");
            const revisionSuffix = getRevisionParams().map((r)=>"&REVISION=" + r).join("");
            return url + "?" + "SERVICE=WFS&VERSION=2.0.0&REQUEST=GetFeature&TYPENAMES=Way&" + "SRSNAME=urn:ogc:def:crs:EPSG::4326&" + "OUTPUTFORMAT=json&" + "BBOX=" + extentTransformed[1] + "," + extentTransformed[0] + "," + extentTransformed[3] + "," + extentTransformed[2] + ",urn:ogc:def:crs:EPSG::4326" + revisionSuffix;
        }, new (0, _geoJSONDefault.default)(), true, {
            Authorization: function() {
                return "Bearer " + azureLoginControl.get("idToken");
            }
        }, function(reason) {
            vectorFeatureControl.set("loadErrorReason", reason ?? "Unknown error");
        }),
        strategy: (0, _loadingstrategy.bbox),
        projection: (0, _proj.get)("EPSG:4326")
    });
    vectorSource.on("addfeature", (event)=>{
        if (event.feature.getGeometry().getType() === "LineString") {
            const geometry = (0, _util.featureTo4326Geometry)(event.feature);
            event.feature.set("lengthCm", (0, _orbisLrSdk.lengthOnPlaneCm)(geometry));
        }
        renameToLRStep(event, "orbis-oneway");
        renameToLRStep(event, "osm-oneway");
        renameToLRStep(event, "orbis-dual_carriageway");
        renameToLRStep(event, "osm-navigability");
        renameToLRStep(event, "orbis-navigability");
        renameToLRStep(event, "lane_border_type");
    });
    vectorSource.on("featuresloadstart", ()=>{
        vectorFeatureControl.set("loading", true);
        vectorFeatureControl.set("loadError", false);
        vectorFeatureControl.set("loadErrorReason", null);
    });
    vectorSource.on("featuresloadend", ()=>{
        vectorFeatureControl.set("loading", false);
    });
    vectorSource.on("featuresloaderror", ()=>{
        vectorFeatureControl.set("loading", false);
        vectorFeatureControl.set("loadError", true);
    });
    addFeatureHandlers.forEach((handler)=>{
        vectorSource.on("featuresloadend", handler);
    });
    const vectorLayer = new (0, _vectorDefault1.default)({
        source: vectorSource,
        minZoom: 15,
        zIndex: 11,
        style: getStyleNormal
    });
    vectorFeatureControl.on("propertychange", function(e) {
        if (e.key !== "loading" && e.key !== "tooLarge" && e.key !== "loadError") propertyChangeHandler(vectorFeatureControl, azureLoginControl, vectorLayer);
        if (e.key === "zoom") {
            const zoom = e.target.get("zoom");
            if (zoom >= vectorLayer.getMinZoom() && zoom <= vectorLayer.getMaxZoom()) vectorFeatureControl.set("active", true);
            else vectorFeatureControl.set("active", false);
        }
    });
    azureLoginControl.on("propertychange", function() {
        if (azureLoginControl.get("idToken") && azureLoginControl.get("idTokenClaims") && azureLoginControl.get("idTokenClaims").roles && azureLoginControl.get("idTokenClaims").roles.includes(role)) vectorFeatureControl.set("enabled", true);
        else vectorFeatureControl.set("enabled", false);
    });
    vectorFeatureControl.on("propertychange", function(e) {
        if (e.key === "selectedRevisions") vectorSource.refresh();
    });
    return vectorLayer;
}
/**
 * @param {WFSControl} vectorFeatureControl
 * @param {AzureLoginControl} azureLoginControl
 * @param {VectorLayer} vectorLayer
 */ function propertyChangeHandler(vectorFeatureControl, azureLoginControl, vectorLayer) {
    if (!azureLoginControl.get("idToken")) {
        vectorLayer.setVisible(false);
        vectorFeatureControl.set("idTokenSet", false);
    } else {
        vectorFeatureControl.set("idTokenSet", true);
        if (vectorFeatureControl.get("vectorToggle") == true) vectorLayer.setVisible(true);
        else // When vectorToggle is not set, the checkbox is not checked, and so the layer is made invisible.
        vectorLayer.setVisible(false);
    }
}
function renameToLRStep(event, tagKey) {
    renameToLR(event, tagKey, "step");
}
function renameToLR(event, tagKey, lrType) {
    if (!tagKey.endsWith(":" + lrType) && event.feature.get(tagKey) !== undefined && event.feature.get(tagKey).includes("#")) {
        event.feature.set(tagKey + ":" + lrType, event.feature.get(tagKey));
        event.feature.unset(tagKey);
    }
}

},{"ol/source/Vector":"7zHxp","ol/layer/Vector":"7ga2c","ol/format/GeoJSON":"aL7Lr","ol/loadingstrategy":"6eznf","ol/proj":"gN0IK","../featureLoaderWithHeaders":"fqVwh","@orbis-lr-sdk/orbis-lr-sdk":"04bfk","../util":"4IC9E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aqJPu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addCrosslinkHoverLayer", ()=>addCrosslinkHoverLayer);
var _style = require("ol/style");
var _vector = require("ol/layer/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/source/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _crosslink = require("./style/crosslink");
function addCrosslinkHoverLayer(map) {
    const vectorSource = new (0, _vectorDefault1.default)({});
    const styleFunction = function(feature) {
        const geometryType = feature.getGeometry().getType();
        // Endpoint markers carry a Point geometry + a markerColor; handle them
        // before isSD(), which assumes a line feature with an id.
        if (geometryType === "Point") return new (0, _style.Style)({
            image: new (0, _style.Circle)({
                radius: 6,
                fill: new (0, _style.Fill)({
                    color: feature.get("markerColor")
                }),
                stroke: new (0, _style.Stroke)({
                    color: "white",
                    width: 2
                })
            }),
            zIndex: 20
        });
        // The connecting ribbon between the matched road and lane sections —
        // semi-transparent fill drawn behind the section lines. Turns red when the
        // relation is out-of-bounds (a member's role runs past its own length).
        if (geometryType === "Polygon") {
            const outOfBounds = feature.get("outOfBounds");
            return new (0, _style.Style)({
                fill: new (0, _style.Fill)({
                    color: outOfBounds ? "rgba(255, 0, 0, 0.3)" : "rgba(0, 90, 255, 0.3)"
                }),
                stroke: new (0, _style.Stroke)({
                    color: outOfBounds ? "rgba(220, 0, 0, 0.7)" : "rgba(0, 70, 220, 0.7)",
                    width: 1
                }),
                zIndex: 5
            });
        }
        // Outer stroke matches the segment's own colour (road green / lane blue);
        // inner stroke is the matching lighter shade.
        let LINE_COLOR;
        let FILL_COLOR;
        if ((0, _crosslink.isSD)(feature)) {
            LINE_COLOR = "green";
            FILL_COLOR = "#c8f5c8"; // light green
        } else {
            LINE_COLOR = "blue";
            FILL_COLOR = "#d4ecfb"; // light blue
        }
        const styles = [
            // linestring
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: LINE_COLOR,
                    width: 7
                }),
                zIndex: 12
            }),
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: FILL_COLOR,
                    width: 5
                }),
                zIndex: 13
            })
        ];
        return styles;
    };
    const vectorLayer = new (0, _vectorDefault.default)({
        source: vectorSource,
        style: styleFunction
    });
    vectorLayer.setZIndex(100);
    map.addLayer(vectorLayer);
    map.on("click", function() {
        vectorSource.clear();
    });
    return vectorLayer;
}

},{"ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/layer/Vector":"7ga2c","ol/source/Vector":"7zHxp","./style/crosslink":"8WCJV","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cmRGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CROSSLINK_MATCH_START_COLOR", ()=>CROSSLINK_MATCH_START_COLOR);
parcelHelpers.export(exports, "CROSSLINK_MATCH_END_COLOR", ()=>CROSSLINK_MATCH_END_COLOR);
parcelHelpers.export(exports, "getCrosslinkLayerHander", ()=>getCrosslinkLayerHander);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _polygon = require("ol/geom/Polygon");
var _polygonDefault = parcelHelpers.interopDefault(_polygon);
var _util = require("../../util");
var _crosslinkRelations = require("../crosslinkRelations");
const CROSSLINK_MATCH_START_COLOR = "#ffd400"; // lower-cm end of the match
const CROSSLINK_MATCH_END_COLOR = "#7c4dff"; // higher-cm end of the match
function getCrosslinkLayerHander(vizVectorSource) {
    return (feature, layer, position)=>{
        const distanceAtFeatureCm = (0, _crosslinkRelations.distanceAlongFeatureCm)(feature, position);
        const featureId = feature.getId();
        const relationsOfFeature = (0, _crosslinkRelations.findCrosslinkRelationsAt)(feature, layer.getSource().getFeatures(), distanceAtFeatureCm);
        if (relationsOfFeature.length > 0) {
            vizVectorSource.clear();
            // Unique suffix per drawn section so the viz source never sees duplicate
            // ids (OpenLayers throws on those) while keeping the original id prefix —
            // CrosslinkHoverLayer's isSD() only inspects the leading "6:".
            let sectionIndex = 0;
            const addSections = (srcFeature, ranges)=>{
                const geometries = ranges.length === 0 ? [
                    srcFeature.getGeometry().clone()
                ] : ranges.map((range)=>(0, _util.sliceOlLineByCm)(srcFeature.getGeometry(), range.startCm, range.endCm));
                geometries.forEach((geometry)=>{
                    const sectionFeature = new (0, _featureDefault.default)({
                        geometry
                    });
                    sectionFeature.setId(`${srcFeature.getId()}#${sectionIndex++}`);
                    vizVectorSource.addFeature(sectionFeature);
                });
                return geometries;
            };
            const addMarker = (coordinate, color)=>{
                const marker = new (0, _featureDefault.default)({
                    geometry: new (0, _pointDefault.default)(coordinate)
                });
                marker.set("markerColor", color);
                marker.setId(`crosslink-marker#${sectionIndex++}`);
                vizVectorSource.addFeature(marker);
            };
            // Mark the matching ends of the road and lane sections. `opposite` (from
            // the relation's direction tag) decides which end pairs with which.
            const addEndpointMarkers = (geomA, geomB, opposite)=>{
                addMarker(firstCoord(geomA), CROSSLINK_MATCH_START_COLOR);
                addMarker(opposite ? lastCoord(geomB) : firstCoord(geomB), CROSSLINK_MATCH_START_COLOR);
                addMarker(lastCoord(geomA), CROSSLINK_MATCH_END_COLOR);
                addMarker(opposite ? firstCoord(geomB) : lastCoord(geomB), CROSSLINK_MATCH_END_COLOR);
            };
            // Semi-transparent ribbon spanning the gap between the matched road and
            // lane sections — a visual cue of what maps to what. The ring walks A
            // start→end, then B back toward A's start: for `same` direction that
            // means B reversed (end→start); for `opposite`, B as-is.
            const addConnectingPolygon = (geomA, geomB, opposite, outOfBounds)=>{
                const a = geomA.getCoordinates();
                const b = geomB.getCoordinates();
                const ring = opposite ? [
                    ...a,
                    ...b
                ] : [
                    ...a,
                    ...b.slice().reverse()
                ];
                ring.push(ring[0]);
                const polygon = new (0, _featureDefault.default)({
                    geometry: new (0, _polygonDefault.default)([
                        ring
                    ])
                });
                polygon.setId(`crosslink-polygon#${sectionIndex++}`);
                // Flags an out-of-bounds relation so the hover layer paints the ribbon
                // red instead of blue (CrosslinkHoverLayer reads this).
                polygon.set("outOfBounds", outOfBounds === true);
                vizVectorSource.addFeature(polygon);
            };
            relationsOfFeature.forEach((relation)=>{
                const memberIdKeys = relation.getKeys().filter((key)=>key.startsWith("relation-member-") && key.endsWith("-id"));
                if (memberIdKeys.length === 0) return false;
                const hoveredMemberIdKey = memberIdKeys.filter((memberIdKey)=>relation.get(memberIdKey) === featureId)[0];
                const otherMemberIdKey = memberIdKeys.filter((memberIdKey)=>relation.get(memberIdKey) !== featureId)[0];
                if (otherMemberIdKey === undefined) return;
                const otherMemberId = relation.get(otherMemberIdKey);
                const otherRole = relation.get(otherMemberIdKey.replace("-id", "-role"));
                const otherFeature = layer.getSource().getFeatures().filter((myFeature)=>myFeature.getId() === otherMemberId)[0];
                if (otherFeature === undefined) return;
                // Only highlight the single section of the other member that matches the
                // section under the cursor. The role LR-encodes participating ranges
                // along each member's own geometry; the hovered member's range index
                // containing the cursor maps to the same index on the other member.
                const hoveredRanges = (0, _util.getRoleRangesCm)(relation.get(hoveredMemberIdKey.replace("-id", "-role")));
                const otherRanges = (0, _util.getRoleRangesCm)(otherRole);
                const cursorIndex = hoveredRanges.findIndex((range)=>distanceAtFeatureCm >= range.startCm && distanceAtFeatureCm <= range.endCm);
                let selectedRanges;
                if (otherRanges.length === 0) selectedRanges = []; // no decodable range → whole geometry
                else if (otherRanges.length === 1) selectedRanges = otherRanges;
                else if (cursorIndex >= 0 && cursorIndex < otherRanges.length) selectedRanges = [
                    otherRanges[cursorIndex]
                ];
                else selectedRanges = otherRanges; // can't pair → fall back to all sections
                // Highlight the hovered member's own section under the cursor too, so
                // both sides of the matched relation light up — not just the other map.
                const hoveredSelectedRanges = cursorIndex >= 0 ? [
                    hoveredRanges[cursorIndex]
                ] : hoveredRanges;
                const hoveredGeometries = addSections(feature, hoveredSelectedRanges);
                const otherGeometries = addSections(otherFeature, selectedRanges);
                const geomA = hoveredGeometries[0];
                const geomB = otherGeometries[0];
                if (geomA !== undefined && geomB !== undefined) {
                    const opposite = isOpposite(getDirectionTag(relation), firstCoord(geomA), lastCoord(geomA), firstCoord(geomB), lastCoord(geomB));
                    // Out-of-bounds: a member's role runs past its own length. Detected
                    // here too (not just in CrosslinkCoverageHandler) so the hover ribbon
                    // can signal it in red.
                    const outOfBounds = rangesOvershoot(hoveredRanges, feature.get("lengthCm")) || rangesOvershoot(otherRanges, otherFeature.get("lengthCm"));
                    addConnectingPolygon(geomA, geomB, opposite, outOfBounds);
                    addEndpointMarkers(geomA, geomB, opposite);
                }
            });
        }
    };
}
// Whether any range ends past the member's own length — the relation is then
// out-of-bounds on that member. Open-ended ranges (Infinity end) mean "till the
// end of the segment" by design, so they don't count.
function rangesOvershoot(ranges, lengthCm) {
    return lengthCm > 0 && ranges.some((range)=>Number.isFinite(range.endCm) && range.endCm > lengthCm);
}
function firstCoord(geometry) {
    return geometry.getCoordinates()[0];
}
function lastCoord(geometry) {
    const coordinates = geometry.getCoordinates();
    return coordinates[coordinates.length - 1];
}
// The crosslink relation's mandatory `direction` tag (same|opposite). Falls
// back to a prefixed/namespaced key (e.g. "<layerId>-direction", ":direction")
// in case the WFS export renames it.
function getDirectionTag(relation) {
    const direct = relation.get("direction");
    if (direct !== undefined) return direct;
    const key = relation.getKeys().find((candidate)=>/(^|[-:])direction$/.test(candidate));
    return key ? relation.get(key) : undefined;
}
// Whether the two sections run in opposite directions. Prefer the crosslink
// `direction` tag; if it's missing/unknown, infer from geometry by choosing the
// endpoint pairing with the shorter total distance.
function isOpposite(direction, aStart, aEnd, bStart, bEnd) {
    const normalized = typeof direction === "string" ? direction.toLowerCase() : direction;
    if (normalized === "same") return false;
    if (normalized === "opposite") return true;
    const sameCost = distance(aStart, bStart) + distance(aEnd, bEnd);
    const oppositeCost = distance(aStart, bEnd) + distance(aEnd, bStart);
    return oppositeCost < sameCost;
}
function distance(a, b) {
    return Math.hypot(a[0] - b[0], a[1] - b[1]);
}

},{"ol/Feature":"iVSSP","ol/geom/Point":"95T6m","ol/geom/Polygon":"3zws5","../../util":"4IC9E","../crosslinkRelations":"gH9IJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7BhHW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultHoverStyles", ()=>defaultHoverStyles);
var _style = require("ol/style");
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
function defaultHoverStyles(feature) {
    const coordinates = feature.getGeometry().getCoordinates();
    const start = coordinates[coordinates.length - 2];
    const end = coordinates[coordinates.length - 1];
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const rotation = Math.atan2(dy, dx);
    const styles = [];
    styles.push(new (0, _style.Style)({
        geometry: new (0, _pointDefault.default)(end),
        image: new (0, _style.Icon)({
            src: "angle-right-icon.svg",
            anchor: [
                0.75,
                0.5
            ],
            rotateWithView: true,
            rotation: -rotation,
            color: "#063970",
            scale: [
                0.2,
                0.2
            ]
        })
    }));
    return styles;
}

},{"ol/style":[["Icon","ib4Ft","default"],["Style","gqpPW","default"]],"ol/geom/Point":"95T6m","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4OXTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurvatureInteractionsOrbisSD", ()=>getCurvatureInteractionsOrbisSD);
parcelHelpers.export(exports, "getCurvatureInteractionsOrbisHD", ()=>getCurvatureInteractionsOrbisHD);
parcelHelpers.export(exports, "getCurvatureInteractionsGenesis", ()=>getCurvatureInteractionsGenesis);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _curvature = require("../style/curvature");
const isInteractive = (feature)=>!feature.get("nonInteractive");
function getCurvatureInteractions(clickStyle, hoverStyle) {
    return function(layer, control) {
        const clickSelect = new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.click),
            filter: isInteractive,
            style: function(feature) {
                return clickStyle(feature);
            }
        });
        clickSelect.on("select", function(e) {
            if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
            else control.set("selectedFeatures", undefined);
        });
        const hoverSelect = new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            filter: isInteractive,
            style: function(feature) {
                return hoverStyle(feature);
            }
        });
        return [
            clickSelect,
            hoverSelect
        ];
    };
}
function getCurvatureInteractionsOrbisSD() {
    return getCurvatureInteractions((0, _curvature.getCurvatureStyleClickOrbisSD), (0, _curvature.getCurvatureStyleHoverOrbisSD));
}
function getCurvatureInteractionsOrbisHD() {
    return getCurvatureInteractions((0, _curvature.getCurvatureStyleClickOrbisHD), (0, _curvature.getCurvatureStyleHoverOrbisHD));
}
function getCurvatureInteractionsGenesis() {
    return getCurvatureInteractions((0, _curvature.getCurvatureStyleClickGenesis), (0, _curvature.getCurvatureStyleHoverGenesis));
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/curvature":"dM5mO","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}]},[], null, "parcelRequire05b1", {})

//# sourceMappingURL=open-maps-restriction-wkt-viewer.32a8ae3f.js.map
